import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { CustomValidator, MyErrorStateMatcher } from 'src/app/services/validation';
import { AccountService } from '../account.service';
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'app-new-password',
  templateUrl: './new-password.component.html',
  styleUrls: ['./new-password.component.scss']
})
export class NewPasswordComponent implements OnInit {
  form!: FormGroup;
  strengthMsg: any;
  msgColor: any;
  username: any;
  matcher = new MyErrorStateMatcher();
  constructor(private accountService: AccountService, private router: Router, private fb: FormBuilder, public snackbarService: SnackbarService) {
    // this.username = JSON.parse(sessionStorage.getItem('username'));
    const user_data = sessionStorage.getItem('username');
    this.username = user_data ? JSON.parse(user_data) : null;
  }

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm() {
    this.form = this.fb.group({
      newPassword: ['', [Validators.required, CustomValidator.password]],
      confirmPassword: ['', Validators.required],
      username: this.username
    }, { validator: this.passwordMatchValidator })
  }

  // passwordConfirm(c: AbstractControl): { invalid: boolean } {
  //   if (c.get('newPassword').value !== c.get('confirmPassword').value) {
  //     return { invalid: true };
  //   }
  // }

  passwordConfirm(c: AbstractControl): { invalid: boolean } | null {
    if (c?.get('newPassword')?.value !== c?.get('confirmPassword')?.value) {
      return { invalid: true };
    }
    return null;
  }
  passwordMatchValidator(control: AbstractControl) {
    const password: string = control.get('newPassword')?.value; // get password from our password form control
    const confirmPassword: string = control.get('confirmPassword')?.value; // get password from our confirmPassword form control
    // compare is the password math
    if (password !== confirmPassword) {
      // if they don't match, set an error in our confirmPassword form control
      control.get('confirmPassword')?.setErrors({ NoPassswordMatch: true });
    }
  }

  passwordstrength() {
    let pwd = this.form.value.newPassword
    if (pwd.length === 6) {
      this.strengthMsg = "Poor Password";
      this.msgColor = "Red";
    } else if (pwd.length >= 7 && pwd.length <= 9) {
      this.strengthMsg = "Weak Password";
      this.msgColor = "#800080";
    }
    else if (pwd.length >= 10 && pwd.length <= 12) {
      this.strengthMsg = "Average Password";
      this.msgColor = "#800080";
    }
    else if (pwd.length >= 13 && pwd.length <= 20) {
      this.strengthMsg = "Strong Password";
      this.msgColor = "green";
    }

  }

  public errorHandling(control: string, error: string) {
    return this.form.controls[control].hasError(error);
  }
  /*genRandonString(length: number) {
    let chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()';
    let charLength = length;
    let result = '';
    for (let i = 0; i < charLength; i++) {
      result += chars.charAt(Math.floor(Math.random() * charLength));
    }
    return result;
  }
  encode(str: string) {
    return this.genRandonString(128) + this.genRandonString(128) + "-" + btoa(str) + "-" + this.genRandonString(128) + this.genRandonString(128);
  }*/

  encryptMessage(message: any, key: any) {
    const keySize = 512; // 256 bits
    const iterations = 1000;

    const encrypted = CryptoJS.AES.encrypt(message, key, {
      keySize: keySize / 16,
      //iv: salt,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
      iterations: iterations
    });

    return encrypted.toString();
  }

  encodeSalt(str: string, key: string) {
    const ciphertext = this.encryptMessage(str, key);
    //return btoa(ciphertext);
    return btoa(ciphertext);
  }

  submit() {
    if (this.form.valid) {

      let saltReq = {
        username: this.username
      }
      this.accountService.getAuthenticationSalt(saltReq).subscribe((dataSalt: any) => {

        if (dataSalt['status'] == 200) {
          let req = {
            username: this.username,
            password: this.encodeSalt(this.form.get('newPassword')?.value, dataSalt['salt']),
          }
          this.accountService.createNewPass(req).subscribe((data: any) => {
            this.openSnackbar(data['message']);
            this.router.navigate(['/auth/login']);
          }
            , error => {
              let message = error.error || error.error[0];
              this.openSnackbar(message.error);
            })
        }

      }, error => {
        let message = error.error || error.error[0];
        this.openSnackbar(message.error);
      })

    }
  }

  /**
* open toaster for showing message 
*/
  openSnackbar(message: string) {
    this.snackbarService.open(message);
  }

}
